import React from 'react';
import { Grid, GridCell, Text } from 'shared';

import styles from './Empty.module.scss';

type EmptyProps = {
  Icon?: React.FC;
  title?: string;
  description?: string;
};

const Empty = ({ Icon, title, description }: EmptyProps) => {
  return (
    <Grid align="center" valign="center" cellPadding="xl">
      <GridCell>
        <div className={styles.Empty}>
          {Icon && (
            <div className="stack-s inline-block mb-4">
              <Icon />
            </div>
          )}
          {title && (
            <Text color="light" size="m" weight="semibold" stack="xs">
              {title}
            </Text>
          )}
          {description && (
            <Text color="light" size="s" weight="semibold">
              {description}
            </Text>
          )}
        </div>
      </GridCell>
    </Grid>
  );
};

export default Empty;
